import { api } from '@/shared/api/httpClient'
import type { TokenPair } from '@/shared/api/tokenStorage'
import type { User } from '@/shared/auth/types'

export const authApi = {
  // O backend autentica por e-mail (USERNAME_FIELD = "email"); o simplejwt nomeia
  // o campo do payload com o próprio USERNAME_FIELD.
  obtainToken: (email: string, password: string) =>
    api.post<TokenPair>('/auth/token/', { email, password }, { auth: false }),

  me: () => api.get<User>('/auth/me/'),
}
